import { useTheme } from '@/hooks/useTheme';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      className={`relative w-14 h-7 rounded-full transition-all duration-300 flex items-center p-1 cursor-pointer ${
        isDark
          ? 'bg-white/10 hover:bg-white/15 border border-white/10'
          : 'bg-gray-200 hover:bg-gray-300 border border-gray-300'
      }`}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {/* Sun icon */}
      <span
        className={`absolute left-1.5 transition-all duration-300 ${
          isDark ? 'opacity-0 scale-75' : 'opacity-100 scale-100'
        }`}
      >
        <i className="ri-sun-line text-sm text-amber-500"></i>
      </span>

      {/* Moon icon */}
      <span
        className={`absolute right-1.5 transition-all duration-300 ${
          isDark ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
        }`}
      >
        <i className="ri-moon-line text-sm text-cyan-400"></i>
      </span>

      {/* Toggle circle */}
      <span
        className={`w-5 h-5 rounded-full transition-all duration-300 transform ${
          isDark
            ? 'translate-x-7 bg-[#0E1116]'
            : 'translate-x-0 bg-white shadow-sm'
        }`}
      />
    </button>
  );
}